import {BrowserRouter} from 'react-router-dom';
import Modal from 'react-modal';
import App from './components/App';
import {StrictMode} from "react";
import {createRoot} from "react-dom/client";
import 'normalize.css';
import registerServiceWorker from './registerServiceWorker';
import {msalConfig} from "./authConfig";
import {PublicClientApplication} from "@azure/msal-browser";
import {MsalProvider} from "@azure/msal-react";

Modal.setAppElement('#root');

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
const msalInstance = new PublicClientApplication(msalConfig);
root.render(
    <MsalProvider instance={msalInstance}>
    <StrictMode>
        <BrowserRouter>
            <App/>
        </BrowserRouter>
    </StrictMode>
    </MsalProvider>
);

registerServiceWorker();
